module.exports = __webpack_public_path__ + "img/kim-sad.21df4d8a.svg";